import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Col, Modal, notification, Row, Tag } from "antd";
import { useEffect, useState } from "react";
import { drawerActions, listagemActions, manutencaoActions } from "../../actions";
import { BreadcrumbIncluirDados, Editar, Excluir, PesquisaOrdenacao, TabelaDados } from "../../components";
import DrawerTipoServico from "./drawer";
import { useStateValue } from "../../state";
import api from "../../services/api";

export default function TipoServico() {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [editando, setEditando] = useState(false);

    useEffect(() => dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: '+tse_id' } }), [listagemActions]);


    function excluirRegistro(dados) {
        api.delete(`TipoServico/Excluir/${dados.tse_id}`).then(
            (res) => {
                notification.success({ message: `Sucesso!`, description: `Configurações excluidas com sucesso!` });
                dispatch({ type: manutencaoActions.CHANGE, data: { dados: null } });
            }).catch(
                (erro) => {
                    notification.error({ message: "erro", description: `${erro}` })
                }
            ).finally(
                () => {
                    dispatch({ type: listagemActions.CHANGE, data: { ordem: '+tse_id' } });
                });
    }

    const modalExcluir = (dados) => {
        Modal.confirm({
            title: 'Excluir?',
            icon: <ExclamationCircleOutlined />,
            content: `Deseja realmente excluir?`,
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                excluirRegistro(dados);
            }
        });
    };


    function editandoTipoServico(dados) {
        setEditando(true);
        dispatch({ type: manutencaoActions.CHANGE, data: { dados } });
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true } });
    }


    return (
        <div className="p-10">
            <BreadcrumbIncluirDados />
            <PesquisaOrdenacao opcoesOrdenacao={[
                { label: "Descrição Crescente", value: "+tse_id" },
                { label: "Descrição Decrescente", value: "-tse_id" }
            ]} />
            <div className="tabela">
                <TabelaDados url="TipoServico/Listar"
                    colunas={[
                        {
                            title: 'Código',
                            width: 75,
                            align: 'center',
                            render: ({ tse_id }) => (
                                <Tag color="processing" className="w-100">
                                    <b>{tse_id}</b>
                                </Tag>
                            ),
                        },
                        {
                            title: 'Descrição',
                            render: ({ tse_descricao }) => {
                                return (
                                    <div>
                                        <b>
                                            {tse_descricao}
                                        </b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Validade (em dias)',
                            render: ({ tse_validade }) => {
                                return (
                                    <div>
                                        <b>{tse_validade}</b>
                                    </div>
                                );
                            },
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: 95,
                            fixed: 'right',
                            render: (dados) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Editar
                                                onClick={() => {
                                                    editandoTipoServico(dados);
                                                }} icon={<EditOutlined />}
                                            />
                                        </Col>
                                        <Col>
                                            <Excluir icon={<DeleteOutlined />} onClick={() => { modalExcluir(dados) }} />
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]} />
            </div>
            <DrawerTipoServico />
        </div>
    );
}



